import { useFilteredRoutes } from './useFilteredRoutes';
import { privateRoutes } from './routesConfig';

import type { RouteConfig } from 'app/types/router';

/** Private routes of the app router with tenant feature gating applied (see useFilteredRoutes). */
export function usePrivateRoutes(): RouteConfig[] {
  return useFilteredRoutes(privateRoutes);
}
